import ApiCaller from '../../config/apiCaller';
import { API_END_POINTS } from '../../config/api-endpoints';

const ROLES = {
  ...API_END_POINTS.ROLES,
  BASE: API_END_POINTS.ROLES.BASE,
  LIST: API_END_POINTS.ROLES.LIST,
};
// Permissions live under API_END_POINTS.PERMISSIONS, not under ROLES
const PERM = {
  MODULES: API_END_POINTS.ROLES.MODULES,
};

// ─── Subadmin: get my roles and permissions (after login) ───────────────────

export const getRolesMeAPI = () => {
  return ApiCaller.get(ROLES.ME).then((res) => res).catch((err) => Promise.reject(err));
};

// ─── Role CRUD ─────────────────────────────────────────────────────────────

export const getRolesAPI = (params = {}) => {
  const body = {
    page: params.page ?? 1,
    limit: params.limit ?? 10,
    sortBy: params.sortBy ?? 'created_at',
    sortOrder: params.sortOrder ?? 'DESC',
  };
  if (params.search) body.search = params.search;
  if (params.status !== undefined) body.status = params.status;
  if (params.module !== undefined) body.module = params.module;

  return ApiCaller.post(API_END_POINTS.ROLES.LIST, body)
    .then((res) => res)
    .catch((err) => Promise.reject(err));
};

export const createRoleAPI = (body) => {
  return ApiCaller.post(API_END_POINTS.ROLES.BASE, body).then((res) => res).catch((err) => Promise.reject(err));
};

export const getRoleByIdAPI = (id) => {
  return ApiCaller.get(`${API_END_POINTS.ROLES.BASE}/${id}`).then((res) => res).catch((err) => Promise.reject(err));
};

export const updateRoleAPI = (id, body) =>
  ApiCaller.put(`${API_END_POINTS.ROLES.BASE}/${id}`, body)
    .then((res) => res)
    .catch((err) => Promise.reject(err));

export const deleteRoleAPI = (id) =>
  ApiCaller.delete(`${API_END_POINTS.ROLES.BASE}/${id}`)
    .then((res) => res)
    .catch((err) => Promise.reject(err));

export const updateRoleStatusAPI = (id, body) =>
  ApiCaller.patch(`${API_END_POINTS.ROLES.BASE}/${id}/status`, body)
    .then((res) => res)
    .catch((err) => Promise.reject(err));

// ─── Permission CRUD ────────────────────────────────────────────────────────
export const getPermissionModulesAPI = () => {
  return ApiCaller.get(PERM.MODULES).then((res) => res).catch((err) => Promise.reject(err));
};

